import moment from 'moment';
import { calculateTargetDatesFromOperator } from '../../services/filtering/api-param-map-service';
import { dateFilterOperators } from '../../containers/base-filter-bar-container/reference-data-criteria-arguments';

const dateFormat = 'MM/DD/YYYY';

export const mapDateTimeFilters = (filter) => {
  const { filterById, criterionArgumentValue, criterionOperatorValue } = filter;

  const dateOperatorType = criterionOperatorValue;
  const selectedDateOrNumberOfDays = criterionArgumentValue;
  if (dateOperatorType === dateFilterOperators.dateOnOrBefore) {
    return {
      id: filterById,
      value: {
        to: moment(selectedDateOrNumberOfDays).add(1, 'days').format(dateFormat),
      },
    };
  }
  if (dateOperatorType === dateFilterOperators.dateOnOrAfter) {
    return {
      id: filterById,
      value: { from: moment(selectedDateOrNumberOfDays).format(dateFormat) },
    };
  }
  if (dateOperatorType === dateFilterOperators.dateCustomRange) {
    return {
      id: filterById,
      value: {
        from: moment(criterionArgumentValue.startRangeDate).format(dateFormat),
        to: moment(criterionArgumentValue.endRangeDate).add(1, 'days').format(dateFormat),
      },
    };
  }
  if (dateOperatorType === dateFilterOperators.dateWithinThePastXDays) {
    return {
      id: filterById,
      value: {
        from: moment().subtract(Number(selectedDateOrNumberOfDays), 'days').format(dateFormat),
        to: moment().add(1, 'days').format(dateFormat),
      },
    };
  }
  if (dateOperatorType === dateFilterOperators.dateWithinTheNextXDays) {
    return {
      id: filterById,
      value: {
        from: moment().format(dateFormat),
        to: moment()
          .add(Number(selectedDateOrNumberOfDays) + 1, 'days')
          .format(dateFormat),
      },
    };
  }
  if (dateOperatorType === dateFilterOperators.dateXDaysAgoOrMore) {
    return {
      id: filterById,
      value: {
        to: moment()
          .subtract(Number(selectedDateOrNumberOfDays) - 1, 'days')
          .format(dateFormat),
      },
    };
  }
  if (dateOperatorType === dateFilterOperators.dateXDaysAheadOrMore) {
    return {
      id: filterById,
      value: {
        from: moment().add(Number(selectedDateOrNumberOfDays), 'days').format(dateFormat),
      },
    };
  }
  const targetDates = calculateTargetDatesFromOperator(dateOperatorType);
  return {
    id: filterById,
    operator: 'Gte',
    value: {
      from: targetDates.greaterThanOrEqualToDate,
      to: targetDates.lessThanDate,
    },
  };
};
